import { z } from "zod";

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

/** `?period=&hideZero=&compare=` on the trial balance: Back keeps them. */
export const trialBalanceSearch = z.object({
  period: z
    .string()
    .regex(/^\d{4}-\d{2}$/)
    .catch("2026-09"),
  hideZero: z.boolean().catch(true),
  compare: z.enum(["none", "previous"]).catch("none"),
  area: z.enum(["cash", "receivables", "payables", "gst"]).optional().catch(undefined),
});
export type TrialBalanceSearch = z.infer<typeof trialBalanceSearch>;

/** The ledger scope for every account: where the trial balance's total row drills. */
export const EVERY = "*";

/** `?account=&from=&to=` on the ledger: a leaf, a class, EVERY, or none (income and costs). */
export const ledgerSearch = z.object({
  account: z.string().min(1).optional().catch(undefined),
  from: isoDate.catch("2026-09-01"),
  to: isoDate.catch("2026-09-30"),
});
export type LedgerSearch = z.infer<typeof ledgerSearch>;

/** `?from=queue`: the entry was opened from the review queue, which it can step through. */
export const journalSearch = z.object({
  from: z.enum(["queue"]).optional().catch(undefined),
});

/** `?type=` preselects an easy entry's tile (quick create links here). */
export const easyEntrySearch = z.object({
  type: z.enum(["OWNER_IN", "OWNER_OUT", "TRANSFER"]).optional().catch(undefined),
});
